import { render, staticRenderFns } from "./ComunicacionBajaConsulta.vue?vue&type=template&id=54a7c9a0&"
import script from "./ComunicacionBajaConsulta.vue?vue&type=script&lang=js&"
export * from "./ComunicacionBajaConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports